import React, {useContext, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {animateScroll as scroll} from 'react-scroll';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import './HeaderHome.css';
import logAdperHeader from './logAdiperHeader.png';
import logoCuidatia from './logoCuidatia5.png';
import {ViewHeaderHome} from './ViewHeaderHome';

/* A function that returns a component that is the header of the page. */
function HeaderHome(_props) {
	const {MenuLateralAux, chageMenuLateralAux} = _props;

	/* A hook that allows to use the context of the user. */
	const [MenuLateral, setMenuLateral] = useContext(UsuarioContext);

	/* A hook that allows to use the context of the user. */
	const [Usuario, setUsuario] = useSessionStore({Usuario: 'Usuario'});

	/* A hook that allows to navigate between routes. */
	const navigate = useNavigate();

	/*
	 * It navigates to the login page.
	 */
	const goLogin = () => {
		if (Usuario.tipo === 'usuarioNormal') {
		} else {
			navigate('/login');
		}
	};
	/**
	 * It navigates to the miPerfil page.
	 */
	const goToPerfil = () => {
		navigate('/miPerfil');
	};
	/**
	 * It navigates to the miDashboard page.
	 */
	const goToMonitor = () => {
		navigate('/monitorCuidados');
	};
	const goToHistorial = () => {
		navigate('/historialCuidados');
	};

	/**
	 * If the user is a normal user or not registered, the page will scroll to the top and the user will be
	 * redirected to the home page
	 */
	const goToInicioMarket = () => {
		scroll.scrollToTop();
		if (Usuario.tipo === 'usuarioNormal' || Usuario.tipo === 'noRegistrado') {
			navigate('/');
		}
	};

	const goToCafeRural = () => {
		scroll.scrollToTop();
		if (Usuario.tipo === 'usuarioNormal' || Usuario.tipo === 'noRegistrado') {
			navigate('/un-cafe-rural');
		}
	};

	/**
	 * It navigates to the carrito page.
	 */
	const goToCarrito = () => {
		navigate('/carrito');
	};
	/**
	 * `const goToNotificaciones = () => { navigate("/notificaciones") }`
	 */
	const goToNotificaciones = () => {
		navigate('/notificaciones');
	};
	/**
	 * It navigates to the mensajes page.
	 */
	const goToMensajes = () => {
		navigate('/mensajes');
	};
	const gotToMiEmpresa = () => {
		navigate('/miEmpresa');
	};
	const goToMisPacientes = () => {
		navigate('/misPacientes');
	};
	const goToHome = () => {
		navigate('/');
	};
	/**
	 * It navigates to the login page if the user is an admin or agency user, otherwise it navigates to the
	 * home page
	 */
	const cerrarSesion = () => {
		if (Usuario.tipo === 'usuarioAdmin' || Usuario.tipo === 'usuarioEmpresa') {
			navigate('/login');
		} else {
			navigate('/');
		}
		setUsuario({
			tipo: 'noRegistrado',
			userName: '',
			email: '',
			imagen: '',
		});
		setMenuLateral(false);
	};

	/* A component that is the header of the page. */
	return (
		<ViewHeaderHome
			goToInicioMarket={goToInicioMarket}
			goToCafeRural={goToCafeRural}
			logAdperHeader={logoCuidatia}
			goLogin={goLogin}
			goToCarrito={goToCarrito}
			goToNotificaciones={goToNotificaciones}
			Usuario={Usuario}
			setUsuario={setUsuario}
			MenuLateral={MenuLateral}
			setMenuLateral={setMenuLateral}
			goToPerfil={goToPerfil}
			goToMonitor={goToMonitor}
			goToHistorial={goToHistorial}
			goToMensajes={goToMensajes}
			cerrarSesion={cerrarSesion}
			gotToMiEmpresa={gotToMiEmpresa}
			goToMisPacientes={goToMisPacientes}
			goToHome={goToHome}
			chageMenuLateralAux={chageMenuLateralAux}
		/>
	);
}

export default HeaderHome;
